__turbopack_context__.v({
  "danger": "icon-button-module__0AZyva__danger",
  "iconButton": "icon-button-module__0AZyva__iconButton",
  "lg": "icon-button-module__0AZyva__lg",
  "md": "icon-button-module__0AZyva__md",
  "neutral": "icon-button-module__0AZyva__neutral",
  "overlay": "icon-button-module__0AZyva__overlay",
  "plain": "icon-button-module__0AZyva__plain",
  "sm": "icon-button-module__0AZyva__sm",
  "solid": "icon-button-module__0AZyva__solid",
  "xl": "icon-button-module__0AZyva__xl",
});
